import styled from 'styled-components';
import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

interface IMinWidth {
  minWidth?: boolean;
}

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
`;

export const Column = styled.div<IMinWidth>`
  font-weight: 500;
  min-width: ${(props) => (props.minWidth ? '0px' : '62px')};
  margin-left: ${size(1)};
  text-align: center;

  &:first-child {
    margin-left: 0;
  }

  ${theme.screens.LtMd} {
    &.smaller {
      min-width: 55px;
    }
  }
`;

export const CountdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: calc(100% - ${size(2)});
  position: relative;
`;

export const CoverLink = styled.a`
  display: block;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const Label = styled.span`
  font-size: 14px;
`;

export const Message = styled.div`
  font-size: 1.5rem;
  margin-bottom: ${size(2)};
  text-align: center;
  max-width: 360px;
  font-weight: 500;
  position: relative;
`;

export const Value = styled.div`
  font-size: 2.5rem;
  line-height: 1;

  &.smaller {
    font-size: 2.25rem;
  }
`;

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.text.onColor};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  position: relative;
  font-family: ${theme.font.family.brand};

  &.stand-alone {
    min-height: 300px;

    ${theme.screens.Md} {
      min-height: 480px;
    }

    ${theme.screens.Lg} {
      min-height: 570px;
    }
  }
`;
